<template>
  <section
    class="portal-notice"
    role="region"
    :aria-label="$t('portalNotice.title')"
  >
    <div class="portal-notice__card">
      <h1 class="portal-notice__title">{{ $t("portalNotice.title") }}</h1>

      <p class="portal-notice__text">
        {{ $t("portalNotice.intro") }}
      </p>

      <div class="portal-notice__actions">
        <a
          class="portal-notice__button"
          :href="ctaHref"
          target="_blank"
          rel="noopener noreferrer"
          @click="emitCtaClick"
        >
          {{ $t("portalNotice.cta") }}
        </a>
      </div>

      <p class="portal-notice__thanks">
        {{ $t("portalNotice.thanks") }}
      </p>

      <p class="portal-notice__text">
        {{ $t("portalNotice.benefits") }}
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: "PortalNotice",
  props: {
    ctaHref: { type: String, required: true },
  },
  methods: {
    emitCtaClick(event) {
      this.$emit("cta-click", event);
    },
  },
};
</script>

<style scoped>
.portal-notice {
}

.portal-notice__card {
  max-width: 860px;
  margin: 0 auto;
  background: #ffffff;
  border: 2px solid #3f3f3f;
  border-radius: 18px;
  padding: 28px 30px;
  box-sizing: border-box;
}

.portal-notice__title {
  margin: 0 0 18px 0;
  text-align: center;
  font-weight: 800;
  font-size: 30px;
  line-height: 1.15;
}

.portal-notice__text {
  margin: 0 0 18px 0;
  font-size: 16.5px;
  line-height: 1.55;
  color: #3a3a3a;
}

.portal-notice__actions {
  display: flex;
  justify-content: center;
  padding: 14px 0 18px;
}

.portal-notice__button {
  display: inline-block;
  text-decoration: none;
  text-align: center;
  padding: 14px 22px;
  width: 100%;
  max-width: 520px;
  background: #12a37a;
  border: 2px solid #2f2f2f;
  color: #0f2f23;
  font-weight: 600;
  font-size: 16px;
  border-radius: 2px;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.25);
  transition: transform 120ms ease, box-shadow 120ms ease, filter 120ms ease;
}

.portal-notice__button:hover {
  filter: brightness(1.03);
  transform: translateY(-1px);
  box-shadow: 0 3px 0 rgba(0, 0, 0, 0.25);
}

.portal-notice__button:active {
  transform: translateY(1px);
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.25);
}

.portal-notice__thanks {
  margin: 0 0 14px 0;
  font-size: 18px;
  font-weight: 800;
}

@media (max-width: 520px) {
  .portal-notice__card {
    padding: 22px 18px;
  }
  .portal-notice__title {
    font-size: 24px;
  }
  .portal-notice__text {
    font-size: 15.5px;
  }
}
</style>
